<section>
  <h2>Firearm Information</h2>
  <div class="card mb-3" *removeIfNoPermission="canViewFTS">
    <div class="card-body">
      <h3 class="card-title h4">Trace Data</h3>
      <table class="temp-bs table table-sm table-bordered w-lg-75" aria-describedby="DataTable">
        <thead>
          <tr>
            <th scope="col">FTS ID</th>
            <th scope="col">Purchase Date</th>
            <th scope="col" *removeIfNoPermission="canAddFTSID"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="gunDetailCustomFields?.FirearmTraceData?.length > 0;else notracedata">
            <tr *ngFor="let data of gunDetailCustomFields?.FirearmTraceData">
              <td>{{ data.FTSID }}</td>
              <td>{{ data?.PurchaseDate | date:"MM/dd/yyyy" }}</td>
              <td class="text-center" *removeIfNoPermission="canAddFTSID">
                <button *ngIf="canRemove(data)" aria-label="Disassociate FTS ID" type="button" class="btn btn-sm btn-danger" [disabled]="!canAddFTSID" title=" Disassociate FTS ID" (click)="removeFTSID(data)"><i class="fa fa-times" aria-hidden="true"></i></button>
              </td>
            </tr>
          </ng-container>
          <ng-template #notracedata>
            <tr>
              <ng-container *removeIfNoPermission="canAddFTSID;else noadd">
                <td colspan="3">No trace data found.</td>
              </ng-container>
              <ng-template #noadd>
                <td colspan="2">No trace data found.</td>
              </ng-template>
            </tr>
          </ng-template>
        </tbody>
      </table>
      <button *removeIfNoPermission="canAddFTSID" type="button" class="btn btn-active" title="Open dialog window to manually enter trace FTS ID." (click)="showManualFTSID()">Add FTS ID</button>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <h3 class="card-title h4">Crime Gun Fields</h3>
      <form [formGroup]="crimeGunForm" novalidate>
        <div class="row my-3">
          <div class="col-md-6">
            <div class="form-check">
              <input id="ObliteratedSerialNumber" type="checkbox" formControlName="ObliteratedSerialNumber" class="form-check-input" />
              <label for="ObliteratedSerialNumber" class="form-check-label">Obliterated serial number?</label>
            </div>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-md-6">
            <label for="AmendedSerialNumber" class="form-label">Amended serial number</label>
            <input id="AmendedSerialNumber" type="text" formControlName="AmendedSerialNumber" class="form-control" maxlength="20" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-md-6">
            <p-triStateCheckbox inputId="GunStolenInput" formControlName="IsStolenGun" label="Stolen gun? {{ crimeGunForm.get('IsStolenGun').value | booleanTransform }}" (onChange)="toggleStolenGunFields()" checkboxTrueIcon="fas fa-check" checkboxFalseIcon="fas fa-times" styleClass="form-check-input"></p-triStateCheckbox>
          </div>
        </div>
        <ng-container *ngIf="crimeGunForm.get('IsStolenGun').value == true">
          <div class="row my-3">
            <div class="col-md-6">
              <label for="DateStolen" class="form-label d-block">Date when gun was stolen</label>
              <p-calendar [tabindex]="0" inputId="DateStolen" formControlName="DateStolen" [showIcon]="true" [showOnFocus]="false" dateFormat="mm/dd/yy" inputStyleClass="form-control" [maxDate]="maxDateRule"></p-calendar>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-md-6">
              <label for="FirearmStolenAgencyState" class="form-label">Agency state</label>
              <select id="FirearmStolenAgencyState" class="form-select" formControlName="StateID" (change)="onSelectState($event['target']['value'])">
                <option value="">Select state</option>
                <option *ngFor="let state of states" value="{{state.StateID}}">{{state.StateName}}</option>
              </select>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-md-6">
              <label for="FirearmStolenLEAgency" class="form-label">LE Agency</label>
              <select id="FirearmStolenLEAgency" class="form-select" formControlName="AgencyID" (change)="onSelectAgency($event['target'])">
                <option value="">Select agency</option>
                <option *ngFor="let agency of filteredAgencies$ | async" value="{{agency.AgencyID}}">{{agency.AgencyName}}</option>
              </select>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-md-6">
              <label for="FirearmStolenLECaseNumber" class="form-label">LE Case #</label>
              <input id="FirearmStolenLECaseNumber" formControlName="LECaseNumber" class="form-control" maxlength="20" />
            </div>
          </div>
          <div class="row my-3">
            <div class="col-md-6">
              <label for="FirearmStolenComments" class="form-label">Comments</label>
              <textarea id="FirearmStolenComments" rows="2" cols="40" pInputTextarea autoResize="autoResize" formControlName="Comments" class="form-control" maxlength="250"></textarea>
            </div>
          </div>
        </ng-container>
        <div class="row my-3">
          <div class="col">
            <button type="button" (click)="onSubmit()" label="Submit" class="btn btn-active">Submit</button>
            <button type="button" (click)="closeFirearmView.emit()" label="Close" class="btn btn-active my-3">Close</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
